module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/MobileHeroSlat2-da2eb7838679449e42563a4221d99984.jpg";